import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { AudienceList } from '@/components/whatsapp/audience-list'
import { useWAAudienceStats } from '@/hooks/useWAAudiences'

export const Route = createFileRoute('/whatsapp-audiences')({
  component: WhatsAppAudiencesPage,
})

function WhatsAppAudiencesPage() {
  const { data: stats } = useWAAudienceStats()

  const subtitle = stats
    ? `${stats.total} audiences · ${stats.dynamic} dynamic · ${stats.manual} manual`
    : 'Loading audiences...'

  return (
    <div className="flex flex-col h-full">
      <Header title="Audiences" subtitle={subtitle} />
      <div className="flex-1 overflow-hidden">
        <AudienceList />
      </div>
    </div>
  )
}
